<template>
  <div>
    <highcharts :options="chartOptions" />
    <div id="svg-chart" hidden />
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import { Chart } from 'highcharts-vue';
import highchartsMore from 'highcharts/highcharts-more';
import exportingInit from 'highcharts/modules/exporting';
import annotations from 'highcharts/modules/annotations';
import toDecimal from '@/filters/decimal';

Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
  },
});

highchartsMore(Highcharts);
exportingInit(Highcharts);
annotations(Highcharts);

export default {
  name: 'BubbleChart',

  components: {
    highcharts: Chart,
  },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    subtitulo: {
      type: String,
      required: false,
      default: '',
    },
    fonte: {
      type: String,
      required: false,
      default: 'Fonte: Sistema Desenvolva',
    },
    descricaoEixoY: {
      type: String,
      required: true,
    },
    descricaoEixoX: {
      type: String,
      required: true,
    },
    dados: {
      type: Array,
      required: true,
    },
    isGetSvg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    chartOptions() {
      const plotLines = [];
      for (let i = 2; i < 10; i += 2) {
        plotLines.push({
          dashStyle: 'dot',
          width: 2,
          value: i,
          zIndex: 3,
        });
      }

      return {
        chart: {
          type: 'bubble',
          plotBorderWidth: 1,
          zoomType: 'xy',
          style: {
            fontFamily: 'Roboto;Arial;sans-serif',
          },
        },
        credits: {
          enabled: true,
        },
        legend: {
          enabled: false,
        },
        title: {
          text: this.titulo,
        },
        subtitle: {
          text: this.fonte,
        },
        xAxis: {
          min: 0,
          max: 10,
          allowDecimals: false,
          gridLineWidth: 0,
          title: {
            text: this.descricaoEixoX.toUpperCase(),
            y: 10,
            style: {
              fontSize: '14pt',
            },
          },
          plotLines,
        },
        yAxis: {
          min: 0,
          max: 10,
          allowDecimals: false,
          startOnTick: false,
          endOnTick: false,
          gridLineWidth: 0,
          title: {
            text: this.descricaoEixoY.toUpperCase(),
            style: {
              fontSize: '14pt',
            },
          },
          maxPadding: 0.2,
          plotLines,
        },
        tooltip: {
          headerFormat: '',
          pointFormatter() {
            const point = this;
            let text = `<table><tr><th colspan="2" style="padding-bottom:4px">${point.item}</th></tr>`
              + `<tr><td style='color:#2D5269;padding:0'>Resultado Comportamental:</td><td style='padding:2px'>${
                toDecimal(point.x)}</td></tr>`
              + `<tr><td style='color:#348ECA;padding:0'>Resultado Técnico:</td><td style='padding:2px'>${
                toDecimal(point.y)}</td></tr>`
              + `<tr><td>Coeficiente de Desempenho do Servidor (CDS):</td><td style='padding:2px'>${
                toDecimal(point.z)}</td></tr>`
              + '</table>';

            if (point.item_dp !== undefined) {
              text
                += `<br><table><th colspan="2" style="padding-bottom:4px">${point.item_dp}</th></tr>`
                + `<tr><td style='color:#2D5269;padding:0'>Resultado Comportamental:</td><td style='padding:2px'>${
                  toDecimal(point.a)}</td></tr>`
                + `<tr><td style='color:#348ECA;padding:0'>Resultado Técnico:</td><td style='padding:2px'>${
                  toDecimal(point.b)}</td></tr>`
                + `<tr><td>Coeficiente de Desempenho do Servidor (CDS):</td><td style='padding:2px'>${
                  toDecimal(point.c)}</td></tr>`
                + '</table>';
            }

            return text;
          },
          footerFormat:
            '<div style="margin: 10px auto 2px auto; font-style: italic">'
            + '<strong>*Cálculo do CDS: </strong>'
            + '<p style="margin: 0">'
            + '(Comportamental x Responsabilidade)/10'
            + '</p>'
            + '</div>',
          hideDelay: 100,
          shared: true,
          useHTML: true,
        },
        plotOptions: {
          series: {
            maxSize: 80,
            minSize: 40,
            dataLabels: {
              enabled: true,
              format: '{point.name}',
            },
          },
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'viewFullscreen',
                'printChart',
                'separator',
                'downloadJPEG',
                'downloadPNG',
                'downloadPDF',
                'downloadSVG',
              ],
            },
          },
        },
        lang: {
          contextButtonTitle: 'Opções do Gráfico',
          decimalPoint: ',',
          viewFullscreen: 'Ver em Tela Cheia',
          printChart: 'Imprimir Gráfico',
          downloadJPEG: 'Baixar como Imagem JPEG',
          downloadPNG: 'Baixar como Imagem PNG',
          downloadPDF: 'Baixar como Documento PDF',
          downloadSVG: 'Baixar como Vetor de Imagem SVG',
          exitFullscreen: 'Sair do modo Tela Cheia',
          loading: 'Carregando...',
          noData: 'Não há dados disponíveis',
        },
        series: [{ data: this.dados }],
      };
    },
  },

  watch: {
    isGetSvg(value) {
      if (value) {
        this.$emit('svg', Highcharts.chart('svg-chart', this.chartOptions).getSVG());
      }
    },
  },
};
</script>
